import { useLingui } from '@lingui/react/macro';

import { DesktopBrandFilter } from '@/components/SharedFilters/BrandFilter/DesktopBrandFilter';

import { useFilters } from '../FiltersState';

export const FiltersBrand = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    brands: { brands, setBrands },
  } = useFilters();

  return (
    <DesktopBrandFilter
      selectedBrands={brands}
      setSelectedBrands={setBrands}
      brandsQuery={{ limit: 500, offset: 0 }}
      tag={tag}
      label={t({ id: 'requests.filters.brand.label', message: 'Item brand' })}
      searchPlaceholder={t({
        id: 'requests.filters.brand.search.label',
        message: 'Search brands',
      })}
      tagMultipleSelectionLabel={(selectedBrandsNumber) =>
        i18n._({
          id: 'requests.filters.brand.multiple',
          message: '{selectedBrandsNumber} brands',
          values: { selectedBrandsNumber },
        })
      }
    />
  );
};
